<style lang="scss" scoped>
.uc-actas {
	border: 1px solid #4b8df8;
	margin-bottom: 15px;
	&-title {
		line-height: 40px;
		background-color: #4b8df8;
		color: #fff;
		padding: 0 15px;
	}
	&-content {
		.uc-item {
			border-bottom: 1px solid #ccc;
			padding: 5px 32%;
			margin: 0;
		}
	}
    .tip-font {
        text-align: center;
        color: #ed4014;
        margin-top: 15px;
        font-size: 15px;
        font-weight: bold;
    }
}
</style>
<style >
.uc-actas .ivu-select-dropdown,
.uc-actas .vview-drop {
	max-height: none;
}
.uc-actas .ivu-scroll-container {
	max-height: 300px;
	height: unset !important;
}
</style>

<template>
	<div>
		<Bread v-bind="bread" />
		<div class="uc-actas">
			<h3 class="uc-actas-title">
				<Icon type="ios-color-wand" size="16"></Icon>
				{{$t('port.actas.title',{defaultValue:'切换为用户身份'})}}
			</h3>
			<Form class="uc-actas-content" ref="form" :label-width="120" @submit.native.prevent>
				<FormItem :label="$t('port.actas.nick',{defaultValue:'当前管理员用户'})" class="uc-item">
					<span>{{userinfo.name}}({{userinfo.id}})</span>
				</FormItem>
				<FormItem :label="$t('port.actas.email',{defaultValue:'目标用户邮箱地址'})" class="uc-item">
					<vSelect v-model="userId" filterable search @on-search="handleSearch">
						<Scroll :on-reach-bottom="handleReachBottom" v-show="userList.length">
							<vOption v-for="item in userList" :value="item.value" :key="item.value">{{ item.label }}</vOption>
						</Scroll>
					</vSelect>
				</FormItem>
			</Form>
			<div class="text-center">
                <div class="tip-font">
                    请关闭本站的其他窗口页面以防止出现用户数据缓存问题
                </div>
				<Button
					class="margin-10 width-10per"
					type="primary"
					@click.native="switchUser"
				>{{$t('port.actas.switch',{defaultValue:' 切换 '}) }}</Button>
			</div>
		</div>
	</div>
</template>

<script>
import Bread from '@/components/bread';
import { mapState, mapGetters } from 'vuex';
import { HttpUserList, HttpSwitchUser } from "@/service/port";
import Cookies from 'js-cookie';
export default {
	components: {
		Bread,
	},
	data() {
		return {
			userId: '',
			userList: [],
			page: 1
		};
	},
	created() {
		if (this.isSuper) {
			this.getUserPaageList();
		} else {
			this.$router.push({ name: 'panel' })
		}
	},
	computed: {
		...mapState(['userinfo']),
		...mapGetters(['isSuper']),
		bread() {
			let data = {};
			switch (this.lang) {
				case 'en':
					data = {
						title: 'Act As A User',
						home: 'Main Panel ',
					};
					break;
				default:
					data = {
						title: '切换为用户身份',
						home: '主面板 ',
					};
					break;
			}
			return data;
		},
	},
	methods: {
		handleReachBottom() {
			this.page += 1;
			return this.getUserPaageList(this._email);
		},
		handleSearch(email) {
			this.page = 1;
			this._email = email || "";
			return this.getUserPaageList(this._email);
		},
		async getUserPaageList(email) {
			return HttpUserList({ "search[CN_email]": email, page: this.page, rows: 20 }).then(
				res => {
					const userList = res.data.content.map((item) => {
						return {
							value: item.id,
							label: `${item.name}(${item.email})`
						}
					})
					this.userList = this.page == 1 ? userList : this.userList.concat(userList);
				}
			);
		},
		async switchUser() {
            // 当前用户登录的用户Id
            let userId = this.$store.state.userinfo.id;
            if (!this.userId) return;
			HttpSwitchUser({ asid: this.userId, logout: 0 }).then(
				res => {
					localStorage.LOGINDATA = '';
                    Cookies.set('token', res.data.astoken, { expires: 14, domain: global.DOMAIN });
                    // cookie中添加当前用户的userId
                    Cookies.set('userId', userId, { expires: 14, domain: global.DOMAIN });
                    localStorage.removeItem("MODULELIST");
                    localStorage.removeItem("SYSSCOPELIST");
                    localStorage.removeItem("NOTICEEVENTTYPES");
                    sessionStorage.removeItem("MENULIST");
					location.reload();
				}
			);
		},
	},
};
</script>
